module.exports = __webpack_public_path__ + "static/media/user.86a20ba5.svg";